import { render, staticRenderFns } from "./delivery-driverreach.vue?vue&type=template&id=4de94c46"
import script from "./delivery-driverreach.vue?vue&type=script&lang=js"
export * from "./delivery-driverreach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports